// Module
var code = "<h2 class=\"interiorSectionHeading\">Account Profile</h2> <ul> <li> <strong>Update your address, email, or phone number.</strong></li> <li> Change your password.</li> <li> Request paperless communications.</li> <li> Authorize individuals who can discuss your account on your behalf.</li> </ul> ";
// Exports
export default code;